import React, {
  CSSProperties,
  FC, useEffect, useRef,
} from 'react';
import {
  Button, Column,
} from './Styles';
import TempFieldUtils from '../../../../../../../lib/TempFieldUtils';
import { lang } from '../../../../../../../lib/utils/utils';

const ReopenButton: FC<Props> = ({
  children,
  callback,
  flowId,
  style,
  langZh,
  langEn,
}) => {
  const btnRef = useRef<any>();
  const enRef = useRef<any>();
  const zhRef = useRef<any>();

  useEffect(() => {
    const interval = setInterval(() => {
      if (enRef.current && zhRef.current) {
        const langValue = lang(langEn, langZh);
        if (langValue === langEn) {
          enRef.current.style.display = 'block';
          zhRef.current.style.display = 'none';
        }
        else {
          enRef.current.style.display = 'none';
          zhRef.current.style.display = 'block';
        }
      }
    }, 100);

    return () => clearInterval(interval);
  }, [langZh, langEn]);

  return (
    <Column style={{ width: '100%' }}>
      <Button
        ref={btnRef}
        style={{ fontFamily: lang('Squad-Bold, Squad', 'PingFangSC-SemiBold, PingFang SC'), fontWeight: lang('bold', 600), ...style }}
        type={'button'}
        onClick={() => {
          if (flowId) {
            // 如果已经点击过一次了，不允许再次点击
            if (TempFieldUtils.aiFlowIds.includes(flowId)) {
              return;
            }
            TempFieldUtils.aiFlowIds.push(flowId);
          }

          btnRef.current.style.transform = `scale(0.9)`;
          setTimeout(() => {
            btnRef.current.style.transform = `scale(1)`;
            // 触发点击回调
            callback();
          }, 50);
        }}
      >
        {children}
        <div style={{ display: 'none', fontFamily: 'Squad-Bold, Squad', fontWeight: 'bold' }} ref={enRef}>
          {langEn}
        </div>
        <div style={{ display: 'none', fontFamily: 'PingFangSC-SemiBold, PingFang SC', fontWeight: 600 }} ref={zhRef}>
          {langZh}
        </div>
      </Button>

      {/* 顶层div，点击后触发按钮点击，增加按钮的点击响应区域 */}
      <div
        onClick={() => {
          btnRef.current.click();
        }}
        style={{ height: 46, width: '100%', marginTop: -45 }}
      />
    </Column>
  );
};

export interface Props {
  children?: any;
  callback: () => void;
  langZh?: any;
  langEn?: any;
  // 流程ID，同一个流程下的按钮，只要点击了一次就加入到流程ID中，避免重复点击
  flowId?: string;
  showAnimation?: boolean;
  disabled?: boolean;
  style?: CSSProperties;
}

export default ReopenButton;
